import React, { useState } from "react";
import Portfolio_data from "./Projects_data";
import "./card.css";

const Card = (props) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }

  return (
    <>
      <div className='box btn_shadow'>
        <div className='img'>
          <img src={props.image} alt='' onClick={toggleModal} />
        </div>
        <div className='category d_flex'>
          <span onClick={toggleModal}>{props.category}</span>
          <label>
            {/* <i className='far fa-heart'></i> {props.totalLike} */}
          </label>
        </div>
        <div className='title'>
          <h2 onClick={toggleModal}>{props.title}</h2>
          <a href='#popup' className='arrow' onClick={toggleModal}>
            <i className='fas fa-arrow-right'></i>
          </a>
        </div>
      </div>

      {/* Popup box */}
      {modal && (
        <div className='modal'>
          <div onClick={toggleModal} className='overlay'></div>
          <div className='modal-content d_flex'>
            <div className='modal-img left'>
              <img src={props.image} alt='' />
            </div>
            <div className='modal-text right'>
              {Portfolio_data.map((value, index) => {
                if (value.title === props.title) {
                  return (
                    <span key={index}>
                      {value.period}
                    </span>

                  );
                }
                return null;
              })}
              <h1>{props.title}</h1>
              {/* Iterate through Portfolio_data to find the matching description */}
              {Portfolio_data.map((value, index) => {
                if (value.title === props.title) {
                  return (
                    <p key={index}>
                      {value.desc}
                      <br />
                      <br />
                      {value.tech}
                    </p>

                  );
                }
                return null;
              })}
              <div className='button f_flex mtop'>
                <button className='btn_shadow'>
                  LIKE THIS <i className='far fa-thumbs-up'></i>
                </button>




                {Portfolio_data.map((value, index) => {
                  if (value.title === props.title) {
                    return (
                      <button className='btn_shadow view_project' key={index}> 
                        <a href={value.link}>VIEW PROJECT <i className='fas fa-chevron-right'></i></a>
                      </button>

                    );
                  }
                  return null;
                })}

              </div>
              <button className='close-modal btn_shadow' onClick={toggleModal}>
                <i className='fas fa-times'></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
